import React from 'react';

const ChrisLoader = () => <div className="pc-loader-chris-wrapper"><div className="pc-loader-chris-loader" /></div>;

export default ChrisLoader;

